
import { Helmet } from "react-helmet-async";

interface SocialMetaTagsProps {
  title: string;
  description: string;
  imageUrl: string;
  url: string;
  type?: string;
  contentType?: string;
  contentId?: string;
}

export function SocialMetaTags({
  title,
  description,
  imageUrl,
  url,
  type = "article",
  contentType,
  contentId
}: SocialMetaTagsProps) {
  // Ensure description is properly truncated
  const truncatedDescription = description && description.length > 160 
    ? `${description.substring(0, 157)}...` 
    : description;

  // Ensure the imageUrl is an absolute URL
  const absoluteImageUrl = imageUrl.startsWith('http') 
    ? imageUrl 
    : `${window.location.origin}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    
  // Use the edge function URL for sharing if contentType and contentId are provided
  let metaUrl = url;
  if (contentType && contentId) {
    const isProd = import.meta.env.PROD;
    if (isProd) {
      metaUrl = `https://jzmgcrxhpzztzljikyoa.supabase.co/functions/v1/social-meta?type=${contentType}&id=${contentId}`;
    }
  }

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={truncatedDescription} />
      
      {/* Canonical link */}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={truncatedDescription} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:image:secure_url" content={absoluteImageUrl} />
      <meta property="og:image:alt" content={title} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={metaUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={truncatedDescription} />
      <meta name="twitter:image" content={absoluteImageUrl} />
      <meta name="twitter:image:alt" content={title} />
      
      {/* Additional meta tags for better social media sharing */}
      <meta property="og:site_name" content="InkWebtoons" />
      <meta property="og:locale" content="pt_BR" />
      
      {/* Ensure proper image dimensions are suggested */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  );
}
